import type { FaireProductEntity } from "../../entity_types/product";

export const p_xpzb46thab: FaireProductEntity = {
  token: "p_xpzb46thab",
  type: "product",
  name: "Little Jesus Figures",
  brandToken: "b_996syxfhau",
  brandName: "Gospel Gear Co",
  imageUrl: "https://cdn.faire.com/fastly/ffc71ac0604c75e676e037d78f7579eab8829d1c352d918a686da78fadb93210.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42df656776a9d4a8aa7d149cb0da07effca5743758dedbf06b8ec0c9f8804c96.jpeg",
    "https://cdn.faire.com/fastly/de944062f81b31a0b56c70a9cbee32c84badee9d8ba77143bb43e53c363a6f93.jpeg",
    "https://cdn.faire.com/fastly/f389ca9b0fafdf90efcb3d945ae4f313a70b72e1106aefcc8e4e568ed54a864a.jpeg",
    "https://cdn.faire.com/fastly/8012276e73f2300405dc90ec2c3c899db8a28e0131d51b7cf5fb6430217b27b8.jpeg"
  ],
  priceDollars: 0.75,
  description: "\nEverybody needs a LITTLE JESUS! \n\nOur PVC mini Jesus figures are at hit at school, church, camp, and social gatherings! Not only are the fun to hide and allow others to “find Jesus” but they are a great conversation starter… Just picture walking up to someone who seems to be having an off day and saying… “you look like you could use a little Jesus” while handing them the figure. \n\nInstant laughs. \n\nHand them out on Halloween, put one in the tree for Christmas, hide them in public places, keep Him in your pocket… the opportunities are endless. \n\nPlant seeds and allow God to do the rest. That’s what these little Jesus Figures do best. Grab one or 100! \n\nOur PVC mini Jesus’ are 3D printed. Each is unique, meaning there may be mini differences in each one from the other! \n\nThey are 1.5 inches tall and about .75 inch wide! \n\nDid we mention they make the perfect Christian gift?!\n",
  tags: [],
  msrpDollars: 1.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:16.825Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
